module.exports = __webpack_public_path__ + "static/KS-19813e0ffd23c5792997bdeb2e811581.jpg";